import axios from 'axios';
import baseService from '../shared/baseService';

const positionService = () => baseService('positions');

const getAllByClientId = (clientId: number) => axios.get(`positions?clientId=${clientId}`);

export default { 
    positionService,
    getAllByClientId
};
